import Auth, { CognitoUser } from '@aws-amplify/auth';
import axios from 'axios';
import { setTimeout } from 'timers';

declare const AWS_REGION: string;
declare const USERPOOL_ID: string;
declare const CLIENT_ID: string;
declare const window: any;
declare const jQuery: any;

if (typeof String.prototype.endsWith !== 'function') {
    String.prototype.endsWith = function (suffix) {
        return this.indexOf(suffix, this.length - suffix.length) !== -1;
    };
}

class CustomStorage implements Storage {
    private memStore: Storage;
    private localStore: Storage;
    length: number;

    constructor(namespace: string) {
        this.memStore = window.sessionStorage;
        this.localStore = window.localStorage;
        this.length = this.memStore.length + this.localStore.length;
    }

    setItem(key: string, item: any) {
        if (key.endsWith('.deviceKey') ||
            key.endsWith('.randomPasswordKey') ||
            key.endsWith('.deviceGroupKey')) {
            this.localStore.setItem(key, item);
        } else {
            this.memStore.setItem(key, item);
        }
        this.length = this.memStore.length + this.localStore.length;
    }

    getItem(key: string) {
        if (key.endsWith('.deviceKey') ||
            key.endsWith('.randomPasswordKey') ||
            key.endsWith('.deviceGroupKey')) {
            return this.localStore.getItem(key);
        } else {
            return this.memStore.getItem(key);
        }
    }

    key(index: number) {
        if (index < this.memStore.length) {
            return this.memStore.key(index);
        }
        return this.localStore.key(index - this.memStore.length);
    }

    clear() {
        this.memStore.clear();
        this.localStore.clear();
        this.length = 0;
    }

    removeItem(key: string) {
        if (key.endsWith('.deviceKey') ||
            key.endsWith('.randomPasswordKey') ||
            key.endsWith('.deviceGroupKey')) {
            this.localStore.removeItem(key);
        } else {
            this.memStore.removeItem(key);
        }
    }
}

Auth.configure(
    {
        // REQUIRED - Amazon Cognito Region
        region: AWS_REGION,
        // OPTIONAL - Amazon Cognito User Pool ID
        userPoolId: USERPOOL_ID,
        //userPoolId: 'us-east-1_tHlQhe7XM',
        // OPTIONAL - Amazon Cognito Web Client ID
        userPoolWebClientId: CLIENT_ID,
        //userPoolWebClientId: '5i90rdhsherm78rhk43f7sv30l',
        authenticationFlowType: 'USER_PASSWORD_AUTH',
        storage: new CustomStorage('pscognito')
    }
);

/**
 * Author: Fatima Aurelia
 * Date: 01/22/2017
 * Version: 1.0
 */
function setupModal() {
    document.addEventListener('click', function (e) {
        e = e || window.event;
        var target: any = e.target || e.srcElement;

        if (target.hasAttribute('data-toggle') && target.getAttribute('data-toggle') == 'modal') {
            if (target.hasAttribute('data-target')) {
                var m_ID = target.getAttribute('data-target');
                document.getElementById(m_ID).classList.add('open');
                e.preventDefault();
            }
        }

        // Close modal window with 'data-dismiss' attribute or when the backdrop is clicked
        if ((target.hasAttribute('data-dismiss') && target.getAttribute('data-dismiss') == 'modal') || target.classList.contains('modal')) {
            var modal = document.querySelector('[class="modal open"]');
            modal.classList.remove('open');
            e.preventDefault();
        }
    }, false);
}

function getInfoFromUserInput() {
    return "";
}

function getInput(id: string) {
    return ((document.getElementById(id) as HTMLInputElement)).value;
}

function getTrimmed(id: string) {
    return ((document.getElementById(id) as HTMLInputElement)).value.trim();
}

function setInput(id: string, value: string) {
    (document.getElementById(id) as HTMLInputElement).value = value;
}

function resetInput(id: string) {
    (document.getElementById(id) as HTMLInputElement).value = '';
}

function show(id: string) {
    document.getElementById(id).style.display = "block";
}

function hide(id: string) {
    document.getElementById(id).style.display = "none";
}

function focusInput(id: string, doNotScroll?: Boolean) {
    (document.getElementById(id) as HTMLInputElement).focus();
    if (!doNotScroll) {
        setTimeout(function () { window.scrollTo && window.scrollTo(0, 0); }, 100);
    }
}

function flash(id: string) {
    show(id);
    setTimeout(function () { hide(id) }, 3000);
}

function setText(id: string, text: string) {
    document.getElementById(id).innerText = text;
}

function resetText(id: string) {
    document.getElementById(id).innerText = '';
}

function setHtml(id: string, html: string) {
    document.getElementById(id).innerHTML = html;
}

function handleGeneralError(err, validationName) {
    if (err.message) {
        setText(validationName + 'ValidationText', err.message)        
    } else {
        setText(validationName + 'ValidationText', err)        
    }
    show(validationName + 'Validation');
}

const PHONE_NUMBER_FORMAT_ERROR = 'Phone number is invalid. Please enter a 10 digit US/Canada phone number';

function handleSecurityCodeError(err, codeInput, validationName, opts?) {
    if (err == 'Code cannot be empty') {
        setText(validationName + 'ValidationText', 'Please enter a valid code.');
    } else if (err.name === 'CodeMismatchException') {
        setInput(codeInput, '');
        if (window.location.href.toLowerCase().indexOf('/verifycontactinfo.aspx') > 0) {
            setHtml(validationName + 'ValidationText', 'The code is invalid or expired. Please <a href="/VerifyContactInfo.aspx">click here</a> to retry or <a href="/home.aspx">click here</a> to continue to PatientSite.');
        } else {
            setHtml(validationName + 'ValidationText', 'The code is invalid or expired.' + (opts && opts.login ? ' Please retry or <a class="login validateLink" href="/login.aspx">login again</a> to get a new one. Please <a class="validateLink" href="/public/loginhelp.aspx?mfa">contact PatientSite Tech Support</a> if you cannot login.' : (opts && opts.invalidCodeMessage) ? opts.invalidCodeMessage : ''));
        }
        if (opts && opts.doNotScroll) {
            focusInput(codeInput, true);
        } else {
            focusInput(codeInput);
        }
    } else if (err.name === 'NotAuthorizedException' || err.name === 'LimitExceededException') {
        if (err.message.indexOf('expired') >= 0) {
            setHtml(validationName + 'ValidationText', 'Code is expired. Please <a class="validateLink" href="/login.aspx">login again</a>');
        } else {
            setHtml(validationName + 'ValidationText', GENERIC_TOO_MANY_ATTEMPTS);
        }
    } else if (opts && opts.phone && err.name === 'InvalidParameterException') {
        setText('mfaCodeValidationText', PHONE_NUMBER_FORMAT_ERROR);
    } else if (err.message) {
        setText(validationName + 'ValidationText', err.message);
    } else {
        setText(validationName + 'ValidationText', err);
    }
    show(validationName + 'Validation');
}

function precheckNewPassword(newPassword, newPassword2, validationName) {
    var validateRegex = /[~`!@#%&\-_{}:;"'<>,\/\[\]\\\^\$\.\|\?\*\(\)]/;
    var password = getInput(newPassword);
    var password2 = getInput(newPassword2);
    var errorCount = 0;
    var genericMessage = "Password did not meet requirements. Please read all password requirements and try again.";
    var message = "";

    if (password == '' || password2 == '') {
        setText(validationName, 'Please enter and confirm your new password.');
        return true;
    }
    if (password != password2) {
        setText(validationName, 'The new passwords you entered do not match. Please try again.');
        return true;
    }
    if (password.length < (window as any).MIN_PASSWORD_LENGTH) {
        message = 'Password did not meet requirements. Password not long enough.';
        errorCount++;
    }
    if (!validateRegex.test(password)) {
        message = 'Password did not meet requirements. Password must contain special characters (do not use = or +).';
        errorCount++;
    }
    if (password == password.toLowerCase() || password == password.toUpperCase()) {
        message = 'Password did not meet requirements. Password must contain a mix of upper and lower case letters.';
        errorCount++;
    }
    if (!/\d/.test(password)) {
        message = 'Password did not meet requirements. Password must contain at least one number.';
        errorCount++;
    }       
    if (errorCount > 1) {
        message = genericMessage;
    }
    if (errorCount >= 1) {
        setText(validationName, message);
        return true;
    }

    return false;
}

function handleNewPasswordError(err, newPassword, newPassword2, validationName) {    
    if (err.message.indexOf('not long enough') >= 0) {
        setText(validationName, 'Password did not meet requirements. Password not long enough.');
    } else if (err.message.indexOf('must have numeric') >= 0) {
        setText(validationName, 'Password did not meet requirements. Password must contain at least one number.');
    } else if (err.message.indexOf('must have uppercase') >= 0 || err.message.indexOf('must have lowercase') >= 0) {
        var password = getInput(newPassword);
        if (password == password.toLowerCase() || password == password.toUpperCase()) {
            setText(validationName, 'Password did not meet requirements. Password must contain a mix of upper and lower case letters.');
        } else {
            setText(validationName, 'Password did not meet requirements. Please read all password requirements and try again.');
        }
    } else if (err.message.indexOf('must have symbol') >= 0) {
        setText(validationName, 'Password did not meet requirements. Password must contain special characters (do not use = or +)');
    } else {
        setText(validationName, 'Password did not meet requirements. Please read all password requirements and try again');
    }        
    resetInput(newPassword);
    resetInput(newPassword2);
    focusInput(newPassword);    
}

var currentUser: any;

function _loginSession(user, p?, reset?) {
    setInput('username', user.username);
    setInput('access_token', user.signInUserSession.accessToken.jwtToken);
    setInput('refresh_token', user.signInUserSession.refreshToken.token);
    setInput('id_token', user.signInUserSession.idToken.jwtToken);
    setInput('p', "" + p);
    reset && reset();
    //console.log('Exchanging for Forms auth cookie');
    document.forms['tokenExchange'].submit();
}

function loginSession(_user, p?, reset?) {
    Auth.currentAuthenticatedUser().then(
        user => {
            user.getCachedDeviceKeyAndPassword();
            //console.log(user.deviceKey);
            _loginSession(user, p, reset);
            /*
            user.setDeviceStatusRemembered({
                onSuccess: function (result) {
                    //console.log('Remembered Device');
                    
                },
                onFailure: function (result) {
                    //console.log('Failed to remember device');
                    _loginSession(user);
                }
            })*/
        }
    )    
}

function setDefaultAction(inputId: string, action: any) {
    var input = document.getElementById(inputId);
    input.onkeydown = function (e: any) {
        e = e || window.event;
        if (e.keyCode == 13) {
            if ((typeof action) === 'string') {
                document.getElementById(action).click();
            } else {
                action();                
            }
            return false;
        }
    };
}

function showLoginView(name) {
    hide(name + 'Validation');
    var views = ['loginWrapper', 'resetWrapper', 'mfaWrapper', 'usernameWrapper', 'newPasswordWrapper'];
    for (let i = 0; i < views.length; i++) {
        if (views[i] === name + 'Wrapper') {
            show(views[i]);
            var c = document.getElementById('formContainer').classList;
            if (name == "newPassword") {                
                c.add('Form_tallContainer');
            } else if (name === "reset") {
                c.add('Form_tallerContainer');
            } else {                
                c.remove('Form_tallContainer');
                c.remove('Form_tallerContainer');
            }
        } else {
            hide(views[i]);
        }
    }
}

function clearPassword() {
    setInput('loginPassword', Array(getInput('loginPassword').length + 1).join("*"));
}

function scrollToFormTop() {    
    location.href = '#formTop';
}

function createResetFunction(p) {
    // Redirect to login if password is not changed within 5 minutes
    setTimeout(function () { p = ""; window.location.href = window.location.pathname }, 10 * 60 * 1000);
    return (function () {        
        return function (e) {
            if (e) {
                e.preventDefault();
            }
            hide('newPasswordValidation');
            if (precheckNewPassword('requireNewPassword', 'requireNewPassword2', 'newPasswordValidationText')) {
                resetInput('requireNewPassword');
                resetInput('requireNewPassword2');
                show('newPasswordValidation');
                return;
            }

            var c = document.getElementById('setRequireNewPassword').classList;
            c.remove('Button_buttonOrange');
            c.add('Button_buttonGrey');

            (Auth.currentAuthenticatedUser() as Promise<CognitoUser>).then(
                user => {
                    if (!p) {
                        window.location.href = window.location.pathname;
                        return;
                    }
                    user.changePassword(p, getInput('requireNewPassword'), function (err) {
                        if (err) {
                            if (err.name === 'InvalidPasswordException' || err.name === 'InvalidParameterException') {
                                handleNewPasswordError(err, 'requireNewPassword', 'requireNewPassword2', 'newPasswordValidationText');
                            } else {
                                setText('newPasswordValidationText', err.message);
                            }
                            resetInput('requireNewPassword');
                            resetInput('requireNewPassword2');                            
                            show('newPasswordValidation');                            
                            c.add('Button_buttonOrange');
                            c.remove('Button_buttonGrey');
                            return;
                        }
                        var username = getTrimmed('loginUsername').toLowerCase();
                        //console.log('Password changed');
                        axios.post('oauthlogin/CognitoSignin.aspx/Sync',
                            { u: username, p: getInput('requireNewPassword') })
                            .then(response => {
                                var reset = function () {
                                    resetInput('requireNewPassword');
                                    resetInput('requireNewPassword2');
                                }
                                
                                //console.log('Logging in');
                                loginSession(user, getInput('requireNewPassword'), reset);
                            })
                    })
                })
        }
    })()
}

const FORGOT_PASSWORD_NOTICE = 'Please note that your username is not your email. If you are unsure of your username, <a class="validateLink" href="/ForgotUsername.aspx">click here</a> to retrieve it.';
const FORGOT_PASSWORD_CODE_MESSAGE = '<span style="font-size: 90%">A security code has been sent to the email address or mobile phone that is on file.' +
    'If you don\'t receive this within 3 minutes, please <a href="#" class="validateLink" onclick="document.getElementById(\'forgotLink\').onclick()">try again</a> or <a class="validateLink" href="/public/loginhelp.aspx?password">contact PatientSite Tech Support</a>.</span>'
const NEW_PASSWORD_MESSAGE = 'Your password has been changed. Please log in with your new password.';
const TIMEOUT_MESSAGE = 'You have been automatically logged out after 18 minutes of inactivity. Any unsent message has been saved to your Draft folder.';

function _loginPage() {
    if (window.location.hash == '#username') {
        setHtml('loginValidationText', 'If the information provided is correct, you will receive your username by email shortly. If you still have trouble signing in, <a class="validateLink" href="/public/loginhelp.aspx?username">contact PatientSite Tech Support</a>');
        show('loginValidation');
    } else if (window.location.hash == "#newPassword") {
        setText('loginValidationText', NEW_PASSWORD_MESSAGE);
        show('loginValidation');
    } else if (window.location.search.indexOf("?timeout=") == 0) {
        setText('loginValidationText', TIMEOUT_MESSAGE);
        show('loginValidation');
    }
    document.getElementById('loginButton').onclick = function (e) {
        e.preventDefault();

        if (getTrimmed('loginUsername') == "" || getInput('loginPassword') == "") {
            setText('loginValidationText', 'Please enter your username and password.');
            show('loginValidation');
            return;
        }

        if (emailIsValid(getTrimmed('loginUsername'))) {
            setHtml('loginValidationText', 'Invalid username. ' + FORGOT_PASSWORD_NOTICE);
            show('loginValidation');
            return;
        }

        var c = document.getElementById('loginButton').classList;
        c.remove('Button_buttonOrange');
        c.add('Button_buttonGrey');
        hide('loginValidation');
        Auth.signIn(getTrimmed('loginUsername').toLowerCase(), getInput('loginPassword'))
            .then(user => {                
                currentUser = user;
                if (user.challengeName === 'SMS_MFA') {                    
                    //clearPassword();
                    //console.log('MFA required');
                    showLoginView('mfa');
                    focusInput('mfaCode');
                    setDefaultAction('mfaCode', document.getElementById('mfaVerify').onclick);
                } else if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
                    const { requiredAttributes } = user.challengeParam; // the array of required attributes, e.g ['email', 'phone_number']
                    // You need to get the new password and required attributes from the UI inputs
                    // and then trigger the following function with a button click
                    // For example, the email and phone_number are required attributes
                    //console.log('Require new password');
                    showLoginView('newPassword');
                    focusInput('requireNewPassword');
                } else {                    
                    Auth.currentAuthenticatedUser().then(
                       user => {
                            if (user.attributes["custom:require_new_pw"] === true ||
                                (/*user.attributes["custom:require_new_pw"] === "CHECK" &&*/
                                    getInput('loginPassword').length < (window as any).MIN_PASSWORD_LENGTH)) {
                                var resetFunction = createResetFunction(getInput('loginPassword'));
                                document.getElementById('setRequireNewPassword').onclick = resetFunction;                                
                                showLoginView('newPassword');
                                focusInput('requireNewPassword');
                                setDefaultAction('requireNewPassword2', document.getElementById('setRequireNewPassword').onclick);
                            } else {                                
                                //console.log(JSON.stringify(user));
                                //console.log('Logged in no MFA required');
                                
                                loginSession(user, getInput('loginPassword'), clearPassword);
                            }
                        }
                    );
                }
            })
            .catch(err => {
                //console.log(err);
                if (err.code === 'UserNotFoundException' || err.code === 'NotAuthorizedException' || err.code === 'InvalidParameterException') {
                    setText('loginValidationText', 'Incorrect username or password');
                    resetInput('loginPassword');
                    focusInput('loginPassword');
                } else if (err.code === 'PasswordResetRequiredException') {
                    setHtml('resetValidationText', 'Your password has been reset. Please enter the security code sent to your email and a new password. If you don\'t receive a code within 3 minutes, please <a class="validateLink" href="/public/loginhelp.aspx?reset">contact PatientSite Tech Support</a>');
                    resetInput('loginPassword');
                    showLoginView('reset');
                    focusInput('resetCode');
                    setDefaultAction('newPassword2', document.getElementById('setNewPassword').onclick);
                } else if (err.code === 'UserLambdaValidationException' && err.message.indexOf("LoginAttemptsExceeded") >= 0) {
                    setHtml('loginValidationText', 'You have exceeded the maximum number of login attempts. Please wait 30 minutes to try again or <a class="validateLink" href="/public/loginhelp.aspx?lockout">contact PatientSite Tech Support</a>.');
                    resetInput('loginPassword');
                    focusInput('loginPassword');
                } else if (err.name === 'MFAMethodNotFoundException') {
                    setHtml('loginValidationText', 'System error. Please <a class="validateLink" href="/public/loginhelp.aspx?system">contact PatientSite Tech Support</a>.');
                    resetInput('loginUsername');
                    resetInput('loginPassword');
                } else if (err.name === 'ResourceNotFoundException') {
                    localStorage.clear();
                    if (!(e as any).retry) {
                        (e as any).retry = true;                                                
                        document.getElementById('loginButton').onclick(e);
                        return;
                    } else {
                        setHtml('loginValidationText', 'Unexpected error. Please try again');                        
                    }
                } else {
                    setText('loginValidationText', err.message);
                }
                c.add('Button_buttonOrange');
                c.remove('Button_buttonGrey');
                show('loginValidation');
            });
    }

    document.getElementById('setRequireNewPassword').onclick = function (e) {
        if (e) {
            e.preventDefault();
        }
        hide('newPasswordValidation');        
        if (precheckNewPassword('requireNewPassword', 'requireNewPassword2', 'newPasswordValidationText')) {
            resetInput('requireNewPassword');
            resetInput('requireNewPassword2');
            focusInput('requireNewPassword');
            show('newPasswordValidation');
            return;
        }
        var username = getTrimmed('loginUsername').toLowerCase();

        var c = document.getElementById('setRequireNewPassword').classList;
        c.remove('Button_buttonOrange');
        c.add('Button_buttonGrey');

        Auth.completeNewPassword(currentUser, getInput('requireNewPassword'), {})
            .then((user) => {
                //console.log('Password changed');
                axios.post('oauthlogin/CognitoSignin.aspx/Sync',
                    { u: username, p: getInput('requireNewPassword') }
                ).then(() => {
                    if (user.challengeName === 'SMS_MFA') {
                        //console.log('MFA required');
                        showLoginView('mfa');
                        focusInput('mfaCode');
                        setDefaultAction('mfaCode', document.getElementById('mfaVerify').onclick);
                    } else {
                        var reset = function () {
                            resetInput('requireNewPassword');
                            resetInput('requireNewPassword2');
                        }
                        //console.log(JSON.stringify(user));
                        //console.log('Logged in no MFA required');                        
                        loginSession(user, getInput('requireNewPassword'), reset);
                    }
                })
                
            })
            .catch(err => {
                c.remove('Button_buttonGrey');
                c.add('Button_buttonOrange');
                
                if (err.code == "MFAMethodNotFoundException") {
                    axios.post('oauthlogin/CognitoSignin.aspx/Sync',
                        { u: username, p: getInput('requireNewPassword') }
                    ).then(() => {
                        window.location.href = "Login.aspx#newPassword";
                    });
                } else if (err.name === 'InvalidPasswordException' || err.name === 'InvalidParameterException') {
                    handleNewPasswordError(err, 'requireNewPassword', 'requireNewPassword2', 'newPasswordValidationText');
                    show('newPasswordValidation');
                } else {
                    setText('newPasswordValidationText', err.message);
                    show('newPasswordValidation');
                }
            })
    }
    
    document.getElementById('setNewPassword').onclick = function (e) {
        if (e) {
            e.preventDefault();
        }
        hide('resetValidation');
                
        if (getTrimmed('resetCode') == '') {
            setText('resetValidationText', 'Please enter a valid security code.');
            focusInput('resetCode');
            show('resetValidation');
            return;
        }
        if (precheckNewPassword('newPassword', 'newPassword2', 'resetValidationText')) {
            resetInput('newPassword');
            resetInput('newPassword2');
            focusInput('newPassword');
            show('resetValidation');
            return;
        }

        var username = getTrimmed('loginUsername').toLowerCase();
        if (getInput('forgotUsername') != '') {
            username = getTrimmed('forgotUsername').toLowerCase();
        }        

        Auth.forgotPasswordSubmit(username, getTrimmed('resetCode'), getInput('newPassword'))
            .then(() => {
                //console.log('Password changed');
                axios.post('oauthlogin/CognitoSignin.aspx/Sync',
                    { u: username, p: getInput('newPassword') }
                ).then(() => {
                    showLoginView('login');
                    resetInput('resetCode');
                    resetInput('newPassword');
                    resetInput('newPassword2');
                    resetInput('forgotUsername');
                    setText('loginValidationText', NEW_PASSWORD_MESSAGE);
                    show('loginValidation');
                    focusInput('loginUsername');
                }).catch(() => {
                    //console.log("Sync failed");
                    showLoginView('login');
                    resetInput('resetCode');
                    resetInput('newPassword');
                    resetInput('newPassword2');
                    resetInput('forgotUsername');
                    setText('loginValidationText', NEW_PASSWORD_MESSAGE);
                    show('loginValidation');
                    focusInput('loginUsername');
                });
            })
            .catch(err => {
                if (err.name === 'ExpiredCodeException' || err.name === 'CodeMismatchException' || (err.message && err.message.indexOf('confirmationCode') > 0)) {
                    setHtml('resetValidationText', 'The code you entered is invalid or expired. Please try again or <a class="validateLink" href="#" onclick="document.getElementById(\'forgotLink\').onclick()">click here</a> to get a new code');
                    resetInput('resetCode');
                    focusInput('resetCode');
                } else if (err.name === 'InvalidPasswordException' || err.name === 'InvalidParameterException') {
                    handleNewPasswordError(err, 'newPassword', 'newPassword2', 'resetValidationText');                    
                } else if (err.name === 'CodeMismatchException') {
                    setText('resetValidationText', 'The security code provided is invalid. Please try again');
                    resetInput('resetCode');
                    focusInput('resetCode');
                } else if (err.name == 'LimitExceededException') {
                    setHtml('resetValidationText', GENERIC_TOO_MANY_ATTEMPTS);
                    resetInput('resetCode');
                    resetInput('newPassword');
                    resetInput('newPassword2');
                } else if (err.message) {
                    setText('resetValidationText', err.message);
                    resetInput('resetCode');
                    resetInput('newPassword');
                    resetInput('newPassword2');
                } else {
                    setText('resetValidationText', err);
                    resetInput('resetCode');
                    resetInput('newPassword');
                    resetInput('newPassword2');
                }
                show('resetValidation');
            })
    }

    document.getElementById('mfaVerify').onclick = function (e) {
        if (e) {
            e.preventDefault();
        }
        hide('mfaValidation');
        Auth.confirmSignIn(currentUser, getInput('mfaCode'), 'SMS_MFA')
            .then(loggedInUser => {
                var user = loggedInUser;
                //console.log('Logged in');

                Auth.currentAuthenticatedUser().then(
                    user => {
                        if (user.attributes["custom:require_new_pw"] === true ||
                            (user.attributes["custom:require_new_pw"] === "CHECK" &&
                                getInput('loginPassword').length < (window as any).MIN_PASSWORD_LENGTH)) {
                            var resetFunction = createResetFunction(getInput('loginPassword'));
                            document.getElementById('setRequireNewPassword').onclick = resetFunction;
                            showLoginView('newPassword');
                            focusInput('requireNewPassword');
                            setDefaultAction('requireNewPassword2', document.getElementById('setRequireNewPassword').onclick);
                        } else {
                            //console.log(JSON.stringify(user));
                            //console.log('Logged in no MFA required');

                            loginSession(user, getInput('loginPassword'), clearPassword);
                        }
                    }
                );
            })
            .catch(err => {
                //console.log(err);
                var wrapper = document.getElementById('mfaWrapper');
                if (window.location.href.toLowerCase().indexOf('/login.aspx') > 0 && wrapper && wrapper.style.display == "block") {
                    handleSecurityCodeError(err, 'mfaCode', 'mfa', { login: true });
                } else {
                    handleSecurityCodeError(err, 'mfaCode', 'mfa');
                }
            });
    }

    document.getElementById('startForgot').onclick = function (e) {
        if (e) {
            e.preventDefault();
        }
        hide('usernameValidation');
        var username = getTrimmed('forgotUsername').toLowerCase();
        if (username == '') {
            setText('usernameValidationText', 'Please enter a username');
            show('usernameValidation');
            return;
        }
        if (emailIsValid(username)) {
            setHtml('usernameValidationText', 'Invalid username. ' + FORGOT_PASSWORD_NOTICE);
            show('usernameValidation');
            return;
        }
        Auth.forgotPassword(username)
            .then(result => {
                document.getElementById('forgotPasswordModal').classList.add('open');
                resetInput('loginPassword');
                resetInput('newPassword');
                resetInput('newPassword2');
                showLoginView('reset');
                var d = result.CodeDeliveryDetails.Destination;
                setHtml('resetValidationText', FORGOT_PASSWORD_CODE_MESSAGE);
                show('resetValidation');
                focusInput('resetCode');
                setDefaultAction('newPassword2', document.getElementById('setNewPassword').onclick);
            })
            .catch(err => {
                //console.log(err);
                if (err && (err.code === 'UserNotFoundException' || err.code === 'InvalidParameterException')) {
                    setHtml('usernameValidationText', 'No verified email or phone # found for this username. Please <a class="validateLink" href="/public/loginhelp.aspx?password">contact PatientSite Tech Support</a>');
                } else if (err && err.code == 'NotAuthorizedException') {
                    setHtml('usernameValidationText', 'You must login with your temporary password and set a new permanent password.');
                } else if (err && err.code == 'LimitExceededException') {
                    setHtml('usernameValidationText', GENERIC_TOO_MANY_ATTEMPTS);
                } else {
                    setText('usernameValidationText', err.message);
                }
                show('usernameValidation');
            })
    }

    document.getElementById('forgotLink').onclick = function (e) {
        if (e) {
            e.preventDefault();
        }
        showLoginView('username');
        focusInput('forgotUsername');
        setHtml('usernameValidationText', FORGOT_PASSWORD_NOTICE);
        show('usernameValidation');
        setDefaultAction('forgotUsername', document.getElementById('startForgot').onclick);
    }

    focusInput('loginUsername');
};

window.loginPage = function () {
    try {
        setupModal();
    } catch {}
    Auth.currentAuthenticatedUser().then(
        user => {
            user.signOut();
            _loginPage();
        }
    ).catch(
        user => {
            _loginPage();
        });
}

function showVerifyContactInfoView(name) {
    hide(name + 'Validation');
    var views = ['emailWrapper', 'codeWrapper'];
    for (let i = 0; i < views.length; i++) {
        if (views[i] === name + 'Wrapper') {
            show(views[i]);
        } else {
            hide(views[i]);
        }
    }
}

function showMfaView(name) {
    hide(name + 'Validation');
    var views = ['phoneVerifyWrapper', 'mfaCodeWrapper'];
    for (let i = 0; i < views.length; i++) {
        if (views[i] === name + 'Wrapper') {
            show(views[i]);
        } else {
            hide(views[i]);
        }
    }
}

// https://tylermcginnis.com/validate-email-address-javascript/
function emailIsValid(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
}

function getCleanPhone(phone) {
    var clean = "";
    for (var i = 0; i < phone.length; i++) {
        if (phone.charCodeAt(i) >= 48 && phone.charCodeAt(i) <= 57) {
            clean += phone.charAt(i);
        }
    }
    return clean;
}

function formatPhone(phone, pressed) {
    var cleanPhone = "";
    var formattedPhone = "";

    cleanPhone = getCleanPhone(phone);
    if (cleanPhone.length < 10 && pressed >= 48 && pressed <= 57) {
        cleanPhone += String.fromCharCode(pressed);
    }

    if (cleanPhone.length >= 1) {
        formattedPhone = "(" + cleanPhone.substring(0, Math.min(cleanPhone.length, 3));
    }
    if (cleanPhone.length >= 3) {
        formattedPhone = formattedPhone + ") " + cleanPhone.substring(3, Math.min(cleanPhone.length, 6));
    }
    if (cleanPhone.length >= 6) {
        formattedPhone = formattedPhone + "-" + cleanPhone.substring(6, Math.min(cleanPhone.length, 10));
    }

    return formattedPhone;
}

function modalAlert(message: string) {
    setText('generalAlertMessage', message);
    jQuery('#alertModal').modal('show');
}


function modalAlert_(message: string) {
    setText('generalAlertMessage', message);
    jQuery('#generalAlert').dialog({
        resizable: false,
        height: "auto",
        modal: true,
        draggable: false,
        buttons: {
            'Ok': function () {
                (window as any).jQuery(this).dialog('close');
            }
        }
    });
}

function debounce(id: string, func: Function) { 
    return function (e) {
        //console.log('debouncing');
        func(e);
        //completePhoneVerify(e);
        document.getElementById(id).onclick = function (e) { };
        setTimeout(function () { document.getElementById(id).onclick = debounce(id, func) }, 1000);
    }
}

const EMAIL_ALREADY_VERIFIED_MESSAGE = 'This email has already been verified and is on file in your account. To update your email, please make any changes then select "Update Email"';

function verifyEmail(e) {
    if (e) {
        e.preventDefault();
    }
    hide('emailValidation');
    if (emailIsValid(getInput('email').trim())) {
        Auth.currentAuthenticatedUser().then(user => {
            if ((document.getElementsByClassName('Banner_bannerTitle')[0] as any).innerText == 'Login Settings' && user.attributes.email == getTrimmed('email') && user.attributes.email_verified) {
                setText('emailValidationText', EMAIL_ALREADY_VERIFIED_MESSAGE);
                show('emailValidation');
                return;
            }
            Auth.updateUserAttributes(user, {
                'email': getInput('email').trim()
            }).then(() => {
                axios.post('VerifyContactInfo.aspx/UpdateEmail',
                    { email: getInput('email').trim() }
                ).then(() => {
                    Auth.verifyCurrentUserAttribute('email').then(() => {
                        if (document.getElementById('emailToVerify')) {
                            document.getElementById('emailToVerify').innerText = getInput('email').trim();
                        }
                        showVerifyContactInfoView('code');
                        document.getElementById('code').focus();
                    }).catch(err => {
                        if (err.name === 'CodeDeliveryFailureException') {
                            setText('emailValidationText', 'Cannot send verification code. Please use a different email.');
                        } else {
                            setText('emailValidationText', err.message);
                        }
                        show('emailValidation');
                    })
                })
            })
        })
    } else {
        setText('emailValidationText', 'Please enter a valid email address');
        show('emailValidation');
    }
}

function updateResendEmail(e) {
    if (e) {
        e.preventDefault();
    }
    resetInput('code');
    showVerifyContactInfoView('email');
    document.getElementById('email').focus();
}

window.verifyContactInfoPage = function () {
    if (document.getElementById('verify')) {
        document.getElementById('email').focus();
        document.getElementById('verify').onclick = verifyEmail;
        setDefaultAction('email', 'verify');
    }

    if (document.getElementById('updateResendEmail')) {
        document.getElementById('updateResendEmail').onclick = updateResendEmail;
    }

    if (document.getElementById('completeVerify')) {
        document.getElementById('completeVerify').onclick = function (e) {
            if (e) {
                e.preventDefault();
            }            
            Auth.currentAuthenticatedUser().then(user =>
                Auth.verifyCurrentUserAttributeSubmit("email", getInput('code')).then(() => {
                    axios.post('VerifyContactInfo.aspx/EmailVerified',
                        { email: getInput('email').trim() }
                    ).then(() => { window.location.href = "VerifyContactInfo.aspx"; })
                }).catch(err => {
                    //console.log(err);
                    handleSecurityCodeError(err, 'code', 'code');
                }))
        };
        setDefaultAction('code', 'completeVerify');
    }

    if (document.getElementById('phoneVerify')) {
        document.getElementById('cellphone').onkeypress = function (e) {
            e.preventDefault();
            setInput('cellphone', formatPhone(getInput('cellphone'), e.charCode));
        }
        document.getElementById('cellphone').focus();

        document.getElementById('phoneVerify').onclick = function (e) {
            if (e) {
                e.preventDefault();
            }
            var phone = getCleanPhone(getInput('cellphone')).trim();
            if (phone && phone.length == 10) {
                Auth.currentAuthenticatedUser().then(user =>
                    Auth.updateUserAttributes(user, {
                        'phone_number': "+1" + phone
                    }).then(() =>
                        Auth.verifyCurrentUserAttribute('phone_number').then(() => {
                            document.getElementById('phoneToVerify').innerText = getInput('cellphone').trim();
                            showMfaView('mfaCode');
                            document.getElementById('mfaCode').focus();
                            })
                            .catch(err => {
                                if (err.name = 'LimitExceededException') {
                                    setText('phoneVerifyValidationText', 'Too many attempts. Please try again later.');
                                    show('phoneVerifyValidation');
                                } else {
                                    handleGeneralError(err, 'phoneVerify');
                                }
                            })
                        )
                        .catch(err => {
                            handleGeneralError(err, 'phoneVerify');
                        })
                )
            } else {
                setText('phoneVerifyValidationText', PHONE_NUMBER_FORMAT_ERROR);
                show('phoneVerifyValidation');
            }
        };
        setDefaultAction('cellphone', 'phoneVerify');
    }

    if (document.getElementById('updateResendSms')) {
        document.getElementById('updateResendSms').onclick = function (e) {
            if (e) {
                e.preventDefault();
            }
            resetInput('mfaCode');
            showMfaView('phoneVerify');
            document.getElementById('cellphone').focus();
        }
    }

    if (document.getElementById('completePhoneVerify')) {
        document.getElementById('completePhoneVerify').onclick = function (e) {
            if (e) {
                e.preventDefault();
            }
            Auth.currentAuthenticatedUser().then(user =>
                Auth.verifyCurrentUserAttributeSubmit("phone_number", getInput('mfaCode')).then(() => {
                    axios.post('VerifyContactInfo.aspx/MfaOptIn',
                        { cellphone: "+1" + getInput('cellphone').trim() }
                    ).then(() => {
                        Auth.setPreferredMFA(user, 'SMS').then(r => {
                            window.location.href = "Validate.aspx";/*
                            user.setDeviceStatusRemembered({
                                onSuccess: function (result) {
                                    //console.log('Remembered Device');
                                    
                                },
                                onFailure: function (result) {
                                    //console.log('Failed to remember device');
                                    window.location.href = "Validate.aspx";
                                }
                            })*/
                        }).catch(err => {
                            //console.log(err);
                            window.location.href = "Validate.aspx";
                        })
                    })
                }).catch(err => {
                    //console.log(err);
                    handleSecurityCodeError(err, 'mfaCode', 'mfaCode', true);
                })
            );
        };
        setDefaultAction('mfaCode', 'completePhoneVerify');
    }

    if (document.getElementById('skipEnroll')) document.getElementById('skipEnroll').onclick = function (e) {
        if (e) {
            e.preventDefault();
        }
        axios.post('VerifyContactInfo.aspx/MfaOptOut', {}
        ).then(() => {
            window.location.href = "Validate.aspx";
        }).catch(err => {
            //console.log(err);
            setText('mfaCodeValidationText', err.message);
            show('mfaCodeValidation');
        })
    }
};

const PASSWORD_EMPTY = "Please enter your current password.";
const NEW_PASSWORD_EMPTY = "Please enter and confirm your new password";
const PASSWORDS_DO_NOT_MATCH = "The new passwords you entered do not match. Please try again";
const PASSWORD_DOES_NOT_MEET_REQUIREMENT = "The new password you entered does not meet the requirements. Please read all password requirements and try again.";
const INVALID_VERIFICATION = "Invalid verification code provided. Please try again.";
const INVALID_CURRENT_PASSWORD = "The current password you entered is not correct. Please try again.";
const TOO_MANY_PASSWORD_ATTEMPTS = "You have entered an incorrect password too many times. Please try again later.";
const GENERIC_TOO_MANY_ATTEMPTS = 'Too many attempts. Please try again later or <a class="validateLink" href="/public/loginhelp.aspx?codelimit">contact PatientSite Tech Support</a>';

window.loginSettingsPage = function () {
    var defaultEmailText = document.getElementById('verifyEmailText').innerText;
    
    function displayEmailStatus(user?: any) {
        Auth.currentAuthenticatedUser({ bypassCache: user == null }).then(user => {
            if (!user.attributes.email_verified) {
                setText('verifiedEmailStatus', 'Unverified');
                setInput('verify', 'Verify Email');
                setText('verifyEmailText', 'Your email is not verified. You will not be able to reset your password if you forget it. Please verify your email now.')
                document.getElementById('verifyEmailText').style.color = '#cf4f04'; 
            } else {
                setText('verifiedEmailStatus', '\u2713 Verified');
                setInput('verify', 'Update Email');
                setText('verifyEmailText', defaultEmailText);
                document.getElementById('verifyEmailText').style.color = ''; 
            }
            show('verifiedEmailStatus');
            show('verifyEmailText');
        });
    }

    function disableMfa(e?: Event) {
        if (e) {
            e.preventDefault();
        }
        Auth.currentAuthenticatedUser({ bypassCache: true }).then(user => {
            Auth.setPreferredMFA(user, 'NOMFA').then(result => {
                Auth.updateUserAttributes(user, { phone_number: '' })
                    .then(() => {
                        hide('disableMfa');
                        show('enableMfa');
                        (document.getElementById('mfaPhone') as HTMLInputElement).disabled = false;
                        resetInput('mfaPhone');
                        hide('verifiedPhone');
                        hide('unverifiedStatus');
                        show('unverifiedPhone');
                    })
            })
        })
    }

    document.getElementById('mfaPhone').onkeypress = function (e) {
        e.preventDefault();
        setInput('mfaPhone', formatPhone(getInput('mfaPhone'), e.charCode));
    };
    Auth.currentAuthenticatedUser({ bypassCache: true }).then(user => {
        (document.getElementById('email') as HTMLInputElement).value = user.attributes.email;
        (document.getElementById('mfaPhone') as HTMLInputElement).value = user.attributes.phone_number ? formatPhone(user.attributes.phone_number.replace("+1", ""), "") : '';
        //console.log(JSON.stringify(user));
        if (user.attributes.phone_number_verified) {
            if (user.preferredMFA === 'SMS_MFA') {
                (document.getElementById('mfaPhone') as HTMLInputElement).disabled = true;
                hide('enableMfa');
                document.getElementById('mfaStatus').innerText = 'Enhanced security is enabled'
            } else {
                hide('disableMfa');
                (document.getElementById('mfaPhone') as HTMLInputElement).disabled = false;
                document.getElementById('mfaStatus').innerText = 'You do not have enhanced security enabled.'
            }
            show('verifiedPhone');
        } else {
            if (user.attributes.phone_number) {
                show('unverifiedStatus');
                setInput('phoneVerify', 'Verify');
            } else {
                hide('unverifiedStatus');
                setInput('phoneVerify', 'Enroll & Verify');
            }
            (document.getElementById('mfaPhone') as HTMLInputElement).disabled = false;
            show('unverifiedPhone');
        }
        displayEmailStatus(user);
    });

    var phoneVerifyClick = function (e) {
        if (e) {
            e.preventDefault();
        }
        hide('phoneVerifyValidation');
        var phone = getCleanPhone(getInput('mfaPhone')).trim();
        Auth.currentAuthenticatedUser({ bypassCache: true }).then(user => {
            if (phone == '') {
                if (user.attributes.phone_number) {
                    disableMfa();                    
                } else {
                    setText('phoneVerifyValidationText', PHONE_NUMBER_FORMAT_ERROR);
                    show('phoneVerifyValidation');
                }
            } else if (phone && phone.length == 10) {                
                Auth.updateUserAttributes(user, {
                    'phone_number': "+1" + phone
                }).then(() => {
                    Auth.verifyCurrentUserAttribute('phone_number')
                        .then(() => {
                            resetInput('mfaCode');
                            showMfaView('mfaCode');
                            focusInput('mfaCode', true);
                        })
                        .catch(err => {
                            //console.log(err);
                            handleSecurityCodeError(err, 'mfaPhone', 'phoneVerify', { doNotScroll: true });
                        })
                }).catch((err) => {
                    //console.log(err);
                    setText('phoneVerifyValidationText', err.message);
                    show('phoneVerifyValidation');
                })                
            } else {
                setText('phoneVerifyValidationText', PHONE_NUMBER_FORMAT_ERROR);
                show('phoneVerifyValidation');
            }
        });
    };

    document.getElementById('phoneVerify').onclick = debounce('phoneVerify', phoneVerifyClick);
    setDefaultAction('mfaPhone', 'phoneVerify');
    var completePhoneVerifyClick = function (e) {
        if (e) {
            e.preventDefault();
        }

        Auth.verifyCurrentUserAttributeSubmit("phone_number", getInput('mfaCode')).then(() => {
            Auth.currentAuthenticatedUser().then(user => {
                Auth.setPreferredMFA(user, 'SMS').then(result => {
                    show('disableMfa');
                    hide('enableMfa');
                    (document.getElementById('mfaPhone') as HTMLInputElement).disabled = true;
                    setText('mfaStatus', 'Enhanced security is enabled');
                    show('verifiedPhone');
                    hide('unverifiedPhone');
                    showMfaView('phoneVerify');
                });
                /* //Don't use enableMFA function. It does not change MFA setting. user Auth.setPreferredMFA
                    user.enableMFA(function (result) {
                        show('disableMfa');
                        hide('enableMfa');
                        resetInput('mfaCode');
                        setText('mfaStatus', 'Enhanced security is enabled');
                        show('verifiedPhone');
                        hide('unverifiedPhone');
                        showMfaView('phoneVerify');
                    })*/
            })
        }).catch(err => {
            //console.log(err);
            handleSecurityCodeError(err, 'mfaCode', 'mfaCode', { doNotScroll: true });
        })
    };
    
    var cancelPhoneVerify = function (e) {
        if (e) {
            e.preventDefault();
        }
        //resetInput('mfaPhone');
        show('phoneVerifyWrapper');
        hide('mfaCodeWrapper');
        resetInput('mfaCode');
        focusInput('mfaPhone', true);
    }

    // Prevent verification from being triggered multiple times with one click
    var debouncedCompletePhoneVerify = function (e) {
        //console.log('Verifying Phone');
        //completePhoneVerify(e);
        document.getElementById('completePhoneVerify').onclick = function (e) { };
        setTimeout(function () { document.getElementById('completePhoneVerify').onclick = debouncedCompletePhoneVerify }, 1000);
    }

    document.getElementById('completePhoneVerify').onclick = debounce('completePhoneVerify', completePhoneVerifyClick);
    setDefaultAction('mfaCode', 'completePhoneVerify');
    document.getElementById('cancelPhoneVerify').onclick = cancelPhoneVerify;

    document.getElementById('disableMfa').onclick = disableMfa;

    document.getElementById('enableMfa').onclick = function (e) {
        if (e) {
            e.preventDefault();
        }
        Auth.currentAuthenticatedUser({ bypassCache: true }).then(user => {            
            Auth.setPreferredMFA(user, 'SMS').then(result => {                
                show('disableMfa');
                hide('enableMfa');
                setText('mfaStatus', 'Enhanced security is enabled');
            })
            /*
            user.enableMFA(function (result) {
                show('disableMfa');
                hide('enableMfa');
                setText('mfaStatus', 'Enhanced security is enabled');
                modalAlert('Enhanced security is now enabled.');
            });*/
        })
    };
    
    document.getElementById('updatePassword').onclick = function (e) {
        if (e) {
            e.preventDefault();
        }
        hide('passwordValidation');
        
        if (getInput('currentPassword') == '') {
            setHtml('passwordValidationText', PASSWORD_EMPTY);
            show('passwordValidation');
            return;
        }

        if (precheckNewPassword('newPassword', 'newPassword2', 'passwordValidationText')) {
            resetInput('newPassword');
            resetInput('newPassword2');
            focusInput('newPassword');
            show('passwordValidation');
            return;
        }

        (Auth.currentAuthenticatedUser() as Promise<CognitoUser>).then(
            user => {
                user.changePassword(getInput('currentPassword'), getInput('newPassword'),
                    function (err, result) {
                        if (err) {                            
                            if (err.name == "NotAuthorizedException") {
                                resetInput('currentPassword');
                                focusInput('currentPassword');
                                setHtml('passwordValidationText', INVALID_CURRENT_PASSWORD);
                            } else if (err.name == "LimitExceededException") {
                                resetInput('currentPassword');
                                focusInput('currentPassword');
                                setHtml('passwordValidationText', TOO_MANY_PASSWORD_ATTEMPTS);
                            } else if (err.name == "InvalidPasswordException" || err.name === 'InvalidParameterException') {
                                handleNewPasswordError(err, 'newPassword', 'newPassword2', 'passwordValidationText');
                            } else {
                                resetInput('currentPassword');
                                resetInput('newPassword');
                                resetInput('newPassword2');
                                focusInput('currentPassword');
                                setText('passwordValidationText', "Your request could not be completed. Unexpected error occurred while changing password: " + err.message);
                            }
                            show('passwordValidation');
                        } else {
                            //console.log('Password changed');
                            axios.post('LoginSettings.aspx/sync', {
                                p: getInput('newPassword')
                            }).then(() => {
                                resetInput('currentPassword');
                                resetInput('newPassword');
                                resetInput('newPassword2');
                                modalAlert('Password has been successfully updated.');
                            })
                        }
                    })
            })
    };

    document.getElementById('verify').onclick = verifyEmail;
    setDefaultAction('email', 'verify');
    
    document.getElementById('completeVerify').onclick = function (e) {
        if (e) {
            e.preventDefault();
        }
        Auth.currentAuthenticatedUser().then(user =>
            Auth.verifyCurrentUserAttributeSubmit("email", getInput('code')).then(() => {
                resetInput('code');
                showVerifyContactInfoView('email');
                displayEmailStatus();
                modalAlert('Your email has been verified and updated.');
            }).catch(err => {
                //console.log(err);
                handleSecurityCodeError(err, 'code', 'code', { doNotScroll: true });
            })
        )
    };
    setDefaultAction('code', 'completeVerify');

    document.getElementById('cancelVerify').onclick = function (e) {
        e.preventDefault();
        resetInput('code');
        showVerifyContactInfoView('email');
        displayEmailStatus();
        modalAlert('Your email has been updated but not verified. You must have a verified email to reset your password.');
    };

    document.getElementById('updatePhone').onclick = function (e) {
        if (e) {
            e.preventDefault();
        }
        hide('phoneValidation');
        if (getTrimmed('primaryPhone') === '') {
            setText('phoneValidationText', 'Best Phone Number is required');
            show('phoneValidation');
        } else {
            axios.post('LoginSettings.aspx/UpdatePhone',
                {
                    'primaryPhone': getInput('primaryPhone'),
                    'otherPhone': getInput('otherPhone')
                }).then((result) => {
                    if (result.data.d === 'SUCCESS') {
                        modalAlert('Phone numbers have been updated');
                    } else {
                        setText('phoneValidationText', result.data.d);
                        show('phoneValidation');
                    }
                });
        }
    };
    setDefaultAction('primaryPhone', 'updatePhone');
    setDefaultAction('otherPhone', 'updatePhone');
};

function checkDobYear(year) {
    if (!year || year.length != 4) {
        return 'Please enter a 4 digit year in Date of Birth.';
    }
    if (year < '1900' || year > '' + new Date().getFullYear()) {
        return 'Please enter a valid year in Date of Birth.';
    }
    return '';
}

window.forgotUsernamePage = function () {
    document.getElementById('forgotButton').onclick = function (e) {
        if (e) {
            e.preventDefault();
        }
        hide('forgotUsernameValidation');
        var firstname = getInput('firstname').trim();
        var lastname = getInput('lastname').trim();
        var email = getInput('email').trim();
        var dd = getInput('dobdd').trim();
        var mm = getInput('dobmm').trim();
        var yyyy = getInput('dobyyyy').trim();

        if (firstname == '' || lastname == '' || email == '' || dd == '' || mm == '' || yyyy == '') {
            setText('forgotUsernameValidationText', 'Please complete all the information requested below');
            show('forgotUsernameValidation');
            scrollToFormTop();
            return;
        }

        var dob = mm + '/' + dd + '/' + yyyy;

        var yearCheck = checkDobYear(yyyy);
        if (yearCheck) {
            setText('forgotUsernameValidationText', yearCheck);
            show('forgotUsernameValidation');
            scrollToFormTop();
            return;
        }
        if (isNaN(Date.parse(dob))) {
            setText('forgotUsernameValidationText', 'Please enter your Date of Birth in Month/Day/Year format');
            show('forgotUsernameValidation');
            scrollToFormTop();
            return;
        }

        if (!emailIsValid(email)) {
            setText('forgotUsernameValidationText', 'Please enter a valid email');
            show('forgotUsernameValidation');
            scrollToFormTop();
            return;
        }

        axios.post('ForgotUsername.aspx/RetrieveUsername',
            {
                'firstName': firstname,
                'lastName': lastname,
                'email': email,
                'dob': dob
            }
        ).then((result) => {
            if (result.data.d == 'SUCCESS') {
                window.location.href = "Login.aspx#username";
                return;
            } else if (result.data.d == 'FAILED') {
                setText('forgotUsernameValidationText', 'Please enter a valid Date of Birth.');
            } else if (result.data.d == 'ATTEMPTS_EXCEEDED') {
                setHtml('forgotUsernameValidationText', GENERIC_TOO_MANY_ATTEMPTS);
            } else {
                setHtml('forgotUsernameValidationText', 'Encountered unexpected error while retrieving username. Please <a class="validateLink" href="/public/loginhelp.aspx?username">contact PatientSite Tech Support</a>');
            }
            show('forgotUsernameValidation');
            scrollToFormTop();
        }).catch(() => {
            setHtml('forgotUsernameValidationText', 'Encountered unexpected error while retrieving username. Please <a class="validateLink" href="/public/loginhelp.aspx?username">contact PatientSite Tech Support</a>');
            show('forgotUsernameValidation');
            scrollToFormTop();
        })
    }
}

